export default __webpack_public_path__ + "static/media/edit.b4f54e37.svg";